import { ImageMenu } from 'Shared/FrameModules/Image/image_menu';

// NOTE: This functionality is duplicated in guide_edit.js
// but because of how tightly coupled it is to the media manager and the
// guide view html, it was difficult to only pull out the image swapping JS, so
// I had to duplicate it.
onDomReady(() => {
   $$('.js-thumb-image').addEvent('mouseenter', ev => {
      let newLargeImage = $(ev.target.get('data-fullimg'));
      let oldLargeImage = newLargeImage.getParent().getElement('img.visible');

      oldLargeImage.hide().removeClass('visible');
      newLargeImage.show().addClass('visible');

      let menu = ImageMenu.getMenu(oldLargeImage);
      if (menu) {
         menu.disable();
         menu = ImageMenu.getMenu(newLargeImage);
         if (!menu) {
            menu = ImageMenu.installMenu(newLargeImage);
            newLargeImage.addClass('hasMenu');
         }
         menu.enable();
      }
   });
});
